/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finals_Seeding_ProjectedInputs */



/**
* | output |
* | --- |
* | "Projected seeding from the current standings." |
*
* @param {Finals_Seeding_ProjectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finals_seeding_projected = /** @type {((inputs?: Finals_Seeding_ProjectedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finals_Seeding_ProjectedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Placement prévisionnel d'après le classement actuel.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clasificación prevista según la clasificación actual.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Composição prevista com base na classificação atual.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Composizione prevista in base alla classifica attuale.")
	return /** @type {LocalizedString} */ ("Projected seeding from the current standings.")
});